<template>
	
		<HeaderBlock bgcolor="#00000000" border="0" />
	
		<div class="simplePage" v-if="!about" style="margin-top: -40px;">
			<img src="../assets/benefits.png" />
			<h1>You may be entitled to benefits</h1>
			<p>Based on your circumstances, we believe you may be entitled to some support.  Our calculator could help you access unclaimed benefits, maximise your income and reduce your bills. </p>
			<div class="anchor-bottom">
				<v-btn class="mg-button" @click="startSurvey">Find out more<span class="tick"><img class="arrow" :src="require('@/assets/light-arrow-right.png')" /></span></v-btn>
			</div>
		</div>
</template>

<script>
import Services from '../mixins/Services';
import HeaderBlock from './elements/HeaderBlock.vue';

export default {
	mixins: [Services],
	components: {HeaderBlock},
	data() {
		return {
		}
	},
	methods: {
		onLoad: async function() {
			this._getCustomer();
		},
		startSurvey: function() {
			this._getQuestionnaireByKey('InBest', (q) => {
				console.log(q, 'Found this questionnaire');
				this.$router.replace({path: '/Questionnaire/' + q.id, query: {theme: 'dark', allowBack: true, allowSkip: false, escapeRoute:'you'}});
			});	
		}
	},
	mounted: function () {
		this.onLoad();
	},
}
</script>

<style scoped>

.simplePage {
	text-align: center;
	.v-col{
		padding: 0px;
	}
	.well {
		margin-top: 45px;
		padding: 25px;
		background-color: #f5f3f5;
		border-radius: 24px;
		h1{
			font-size: 16px;
		}
	}
	img {
		width: 96px;
		margin-bottom: 15px;
		margin-top: 15px;
	}
	h1 {
		font-size: 24px;
		margin-top: 8px;
		margin-bottom: 15px;
		text-align: center;
	}
	p {
		margin-top: 15px;
		margin-bottom: 15px;
		font-size: 14px;
		text-align: center;
	}
	.info {
		text-align: left;
		padding: 15px;
		background-color: var(--background-color-alt);
		border-radius: 6px;
		h1{
			font-weight: bold;
			font-size: 12px;
		}
		p {
			font-size: 12px;
			margin-top: 15px;
			margin-bottom: 15px;
		}
	}
	.tick {
		text-align: right;
		float: right;
	}
	.arrow {
		margin-top: 20px;
		width: 12px;
		margin-left: 10px;
	}
	.partnership{
		margin-top: 30px;
		text-align: center;
		img {
			margin: 0px;
			margin-left: 5px;
			margin-bottom: -5px;
			width: 64px;
		}
	}
	
}

@media(max-height: 800px) {
  .anchor-bottom {
    margin-top: 20px;
    position: unset;
    padding-bottom: 30px;
  }
}

</style>
